import { useRouteLoaderData } from "react-router";
import type { RootLoaderData } from "@/loaders/root-loader";

export interface SurveyAuth {
  userName: string;
  tenantId?: string;
  role?: "admin" | "member" | "viewer";
  isAdmin: boolean;
}

/** root loader の whoami から現在テナントのロール等を導出する。 */
export function useAuth(): SurveyAuth {
  const data = useRouteLoaderData("root") as RootLoaderData | undefined;
  const auth = data?.auth;
  const membership = auth?.memberships.find(
    (m) => m.tenantId === auth?.currentTenantId,
  );
  const role = membership?.role;
  return {
    userName: auth?.user?.name ?? "",
    tenantId: auth?.currentTenantId,
    role,
    isAdmin: role === "admin",
  };
}
